import classNames from 'classnames/bind';
import { SVGS } from '~/assets/assetsPath';
import styles from './Common.module.scss';

const cx = classNames.bind(styles);

function NoData({ text, ...props }) {
    return (
        <div className={cx('no_service')} {...props}>
            <img src={SVGS.IconNoService} alt="" />
            <span>{text}</span>
        </div>
    );
}

export default NoData;
